import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { sitesOptions } from "../queries/sitesQueries";
import type { IDomainFavicon, IDomainsFaviconsQueryOptions } from "../types";

export const useDomainsFavicons = (
    domains: string[],
    options?: IDomainsFaviconsQueryOptions,
): UseQueryResult<IDomainFavicon[]> => {
    return useQuery({
        ...sitesOptions.domainsFavicons(domains, options),
    });
};
